import { FormErrorMessage } from "@msuite/picasso";
import { z } from "zod";

export const addPlanningRequestSchema = z.object({
	dueAt: z.string().min(1),
	address: z.string().min(1),
	auftraggeber: z.string().min(1),
	projectNumber: z.string().optional(),
	projectName: z.string().min(1),
	statik: z.boolean(),
	planunterlagen: z.boolean(),
	anforderungen: z.string().optional(),
	sonstiges: z.string().optional(),
});

export type AddPlanningRequestFormType = z.infer<typeof addPlanningRequestSchema>;

export const FormError = FormErrorMessage<AddPlanningRequestFormType>;
